/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputEwFrequencyRangeInput } from './InputEwFrequencyRangeInput';
import {
    InputEwFrequencyRangeInputFromJSON,
    InputEwFrequencyRangeInputFromJSONTyped,
    InputEwFrequencyRangeInputToJSON,
} from './InputEwFrequencyRangeInput';

/**
 * 
 * @export
 * @interface InputEwSuppressionSessionCreate
 */
export interface InputEwSuppressionSessionCreate {
    /**
     * 
     * @type {string}
     * @memberof InputEwSuppressionSessionCreate
     */
    directionName?: string;
    /**
     * 
     * @type {number}
     * @memberof InputEwSuppressionSessionCreate
     */
    durationMinutes: number;
    /**
     * 
     * @type {Array<InputEwFrequencyRangeInput>}
     * @memberof InputEwSuppressionSessionCreate
     */
    frequencyRanges: Array<InputEwFrequencyRangeInput>;
    /**
     * 
     * @type {string}
     * @memberof InputEwSuppressionSessionCreate
     */
    scheduledAt: string;
    /**
     * 
     * @type {number}
     * @memberof InputEwSuppressionSessionCreate
     */
    zoneId: number;
}

/**
 * Check if a given object implements the InputEwSuppressionSessionCreate interface.
 */
export function instanceOfInputEwSuppressionSessionCreate(value: object): boolean {
    if (!('durationMinutes' in value)) return false;
    if (!('frequencyRanges' in value)) return false;
    if (!('scheduledAt' in value)) return false;
    if (!('zoneId' in value)) return false;
    return true;
}

export function InputEwSuppressionSessionCreateFromJSON(json: any): InputEwSuppressionSessionCreate {
    return InputEwSuppressionSessionCreateFromJSONTyped(json, false);
}

export function InputEwSuppressionSessionCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputEwSuppressionSessionCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'directionName': json['directionName'] == null ? undefined : json['directionName'],
        'durationMinutes': json['durationMinutes'],
        'frequencyRanges': ((json['frequencyRanges'] as Array<any>).map(InputEwFrequencyRangeInputFromJSON)),
        'scheduledAt': json['scheduledAt'],
        'zoneId': json['zoneId'],
    };
}

export function InputEwSuppressionSessionCreateToJSON(value?: InputEwSuppressionSessionCreate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'directionName': value['directionName'],
        'durationMinutes': value['durationMinutes'],
        'frequencyRanges': ((value['frequencyRanges'] as Array<any>).map(InputEwFrequencyRangeInputToJSON)),
        'scheduledAt': value['scheduledAt'],
        'zoneId': value['zoneId'],
    };
}

